import moment from 'moment'

export const calculateEndDateRange = (recurringDistribution) => {
  const startMonth = recurringDistribution?.startMonth
  const startDate = recurringDistribution?.dayRepeats
  const now = moment()
  let startDateObj

  if (!startMonth || !startDate) {
    startDateObj = now.clone().startOf('day')
  } else {
    const currentMonthNum = now.month() + 1
    const startMonthNum = Number(startMonth)

    const yearOffset = startMonthNum < currentMonthNum ? 1 : 0

    startDateObj = moment()
      .year(now.year() + yearOffset)
      .month(Number(startMonth) - 1)
      .date(Number(startDate))
      .startOf('day')
  }

  return {
    minEndDate: startDateObj.clone().add(3, 'months').format('YYYY-MM-DD'),
    maxEndDate: startDateObj.clone().add(1, 'year').endOf('month').format('YYYY-MM-DD'),
  }
}

export const isEndDateOutOfRange = (endDate, recurringDistribution) => {
  if (!endDate) return false
  const { minEndDate, maxEndDate } = calculateEndDateRange(recurringDistribution)
  return endDate < minEndDate || endDate > maxEndDate
}
